// extracted by css-extract-rspack-plugin
export default {"controls":"Controls-module__controls___OMqS4","link":"Controls-module__link___MCvWC","label":"Controls-module__label___vucU9","dropdown":"Controls-module__dropdown___yqOVt"};